import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.create";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PropTypes from 'prop-types';
import SplashHeader from './SplashHeader';
import SplashRegions from './SplashRegions';
import withDevice from '../../../with-device/with-device';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import CmsPrint from '../../renderers/cms-print-button/CmsPrint';
import styles from './DynamicSplash.less';
export var DynamicSplash = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DynamicSplash, _React$PureComponent);

  var _super = _createSuper(DynamicSplash);

  function DynamicSplash() {
    _classCallCheck(this, DynamicSplash);

    return _super.apply(this, arguments);
  }

  _createClass(DynamicSplash, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var metadata = this.props.metadata;

      if (metadata && metadata.nav_page_title) {
        document.title = metadata.nav_page_title;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          metadata = _this$props.metadata,
          regions = _this$props.regions,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          device = _this$props.device,
          templateType = _this$props.templateType,
          pageTemplate = _this$props.pageTemplate;
      var navPageHeader = metadata && metadata.nav_page_header;
      var navPageDisplay = metadata && metadata.page_header_display;
      return /*#__PURE__*/React.createElement("main", {
        role: "main",
        id: title,
        className: getClasses({
          styles: styles,
          classes: ['splash-container', className, 'color12'],
          device: device
        })
      }, pageTemplate && pageTemplate.title !== 'securesitejump' && /*#__PURE__*/React.createElement(SplashHeader, {
        nav_page_header: navPageHeader,
        page_header_display: navPageDisplay
      }), /*#__PURE__*/React.createElement("div", null, metadata && metadata.show_print && /*#__PURE__*/React.createElement(CmsPrint, null)), /*#__PURE__*/React.createElement(SplashRegions, {
        metadata: metadata,
        regions: regions,
        templateType: templateType
      }));
    }
  }]);

  return DynamicSplash;
}(React.PureComponent);
DynamicSplash.defaultProps = {
  OneLinkShow: false,
  id: '',
  metadata: {},
  pageTemplate: {},
  'publication-id': '',
  regions: {},
  title: '',
  variables: {},
  references: {}
};
DynamicSplash.propTypes = {
  OneLinkShow: PropTypes.bool,
  id: PropTypes.string,
  metadata: PropTypes.object,
  pageTemplate: PropTypes.object,
  'publication-id': PropTypes.string,
  regions: PropTypes.object,
  title: PropTypes.string,
  variables: PropTypes.object,
  references: PropTypes.object,
  className: PropTypes.string,
  device: PropTypes.object,
  templateType: PropTypes.oneOf(['SERVICE', 'MARKETING', 'NOTIFICATION'])
};
export default withDevice(DynamicSplash);